import { useState, useEffect } from "react";
import { useAdors } from "context/AdorsContext";
import { Modal, Card } from 'react-bootstrap';

export default function AdorElCustomList({ adorName }) {

  const handleChange = (e) => {
    e.stopPropagation();
    // Auto format text before update using ador.format_text

    updateAdorValue(ador.ador_name, "user_value", e.target.value);
  }

  const validateAdor = () => {
    // Check required with ador.is_required

    // Check format with ador.validation
  }

  return ador && ador.hidden == 0 && (
    <div className="row">
      <div className="col">
        <label className="form-label">{ador.label}</label>
        <select name={ador.ador_name}
          id={ador.ador_name} class="form-control"
          value={ador.user_value}
          onChange={handleChange}
          readOnly={ador.readonly}
          required={ador.required}
        >
          {
            ador.list_items && ador.list_items.map((item) => {
              <option value={item.id}>{item.nama}</option>
            })
          }
        </select>
      </div>
    </div>
  );
}
